import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Router, useNavigate, Navigate } from "react-router-dom";


import WaitingList from "../../share-users/waiting/WaitingList";
import ConfirmedList from "../../share-users/confirmed/ConfirmedList";
import FailedList from "../../share-users/failed/FailedList";

const EndUserRoutes = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/waiting-list" />} />
        <Route path="/waiting-list" element={<WaitingList />} />
        <Route path="/confirmed-list" element={<ConfirmedList />} />
        <Route path="/failed-list" element={<FailedList />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};
export default EndUserRoutes;
